import {
    ecsApi,
    GetFavoritesResponse,
    GetMeResponse,
    GetMyWorksitesResponse,
    GetUsersResponse,
    SearchUsersPayload,
    SearchUsersResponse
} from '@services';

export const usersApi = ecsApi.injectEndpoints({
    endpoints: (builder) => ({
        getUsers: builder.mutation<GetUsersResponse, void>({
            query: () => ({
                url: '/users',
                method: 'GET'
            })
        }),
        getMe: builder.mutation<GetMeResponse, void>({
            query: () => ({
                url: '/user',
                method: 'GET'
            })
        }),
        getFavorites: builder.mutation<GetFavoritesResponse, void>({
            query: () => ({
                url: '/user/favorites',
                method: 'GET'
            })
        }),
        addFavorite: builder.mutation<void, string>({
            query: (reference: string) => ({
                url: '/user/favorites',
                method: 'POST',
                body: { reference }
            })
        }),
        deleteFavorite: builder.mutation<void, number>({
            query: (id: number) => ({
                url: `/user/favorites/${id}`,
                method: 'DELETE'
            })
        }),
        searchUsers: builder.mutation<SearchUsersResponse, SearchUsersPayload>({
            query: ({ key, value }) => ({
                url: key && value ? `/users/search?${key}=${value}` : '/users/search',
                method: 'GET'
            })
        }),
        getMyWorksites: builder.mutation<GetMyWorksitesResponse, void>({
            query: () => ({
                url: '/user/worksites',
                method: 'GET'
            })
        })
    })
});

export const {
    useGetUsersMutation,
    useGetMeMutation,
    useGetFavoritesMutation,
    useAddFavoriteMutation,
    useDeleteFavoriteMutation,
    useSearchUsersMutation,
    useGetMyWorksitesMutation
} = usersApi;
